import React from 'react';
import CodeDiffLine from '~/components/CodeDiffLine';
import CodeDiffHeader from '~/components/CodeDiffHeader';

interface CocoaPodsProps {
  packageInfo: object;
  filePath: string;
}

const CocoaPods: React.FunctionComponent<CocoaPodsProps> = props => {
  const { name, version } = props.packageInfo;
  const { filePath = 'Podfile.lock' } = props;

  //split Podfile#L5
  const splittedSelectedFilePath = filePath.split('#L');
  const file = splittedSelectedFilePath[0];
  const lineNumber = splittedSelectedFilePath[1] || '';

  return (
    <div>
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <CodeDiffHeader text={file} />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
        <CodeDiffLine
          type="highlight"
          lineNumber={lineNumber}
          text={'- ' + name + ' (' + version + ')'}
        />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    </div>
  );
};

export default CocoaPods;
